export function deriveShiftState(smena, dochazka) {
    if (!smena) return 'no-shift';
    if (!dochazka) return 'pre';                 // žádná dochazka = před zahájením
    if (!dochazka.clock_in) return 'starting';   // dochazka existuje ale clock_in NULL = příprava (vyplňování úvodních checklistů)
    if (dochazka.clock_out) return 'done';

    // Přechod do 'end' jen ručně přes dokončení fáze 'prubeh' (zaměstnanec
    // klikne "Ukončit směnu" → fazePrubeh.stav='done' → UI ukáže ukončovací
    // checklisty + vyúčtování pokladny). Žádný auto-přechod podle času —
    // pozdní příchod by jinak skočil do `end` hned po clock-inu, protože
    // by `cas_do` mohl být v minulosti.
    const fazePrubeh = (smena.faze || []).find(f => f.id === 'prubeh');
    if (fazePrubeh?.stav === 'done') return 'end';

    return 'active';
}
